/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Link } from 'react-router-dom'
import List, { ListItem } from 'elements/List'
import Text from 'elements/Text'

const getComponentByTagName = tagName => {
  if (tagName === 'Link') {
    return Link
  }
  if (tagName === 'Text') {
    return Text
  }
  if (tagName === 'List') {
    return List
  }
  if (tagName === 'ListItem') {
    return ListItem
  }
  return tagName
}

export const renderNodes = (astNodes) => {
  return astNodes.reduce((acc, astNode, index) => {
    if (astNode.type === 'text') {
      return acc.concat(astNode.content)
    }
    if (astNode.type === 'tag') {
      return acc.concat(React.createElement(
        getComponentByTagName(astNode.name),
        { ...astNode.attrs, key: index },
        [renderNodes(astNode.children)],
      ))
    }
  }, [])
}
